module.exports = {
    ENV: 'prod',
    APP_NAME: 'sem',
    END_POINT: 'https://ssm.services.apihf.com',
    API_KEY: 'c09CctEY2UrY7zEBFKkFQKnY3yXUr98w23PTryi0',
    BRAND_KEY: '77c21655-0d82-4cf4-9de1-2e4ee6fc13b3',
    LANG: 'fr-FR'
}